/**
 * Bridge between <input type="datetime-local"> (local wall time, no offset)
 * and API datetimes (UTC ISO-8601, stored as timestamptz).
 */

/** Convert datetime-local value to UTC ISO string for the API. */
export function localDatetimeInputToIsoUtc(value: string | undefined | null): string | undefined {
  if (value == null || !String(value).trim()) return undefined;
  const d = new Date(String(value).trim());
  if (Number.isNaN(d.getTime())) return undefined;
  return d.toISOString();
}

/** Convert API instant (ISO with Z or offset) to datetime-local string in the user's timezone. */
export function isoUtcToDatetimeLocalValue(iso: string | undefined | null): string {
  if (iso == null || !String(iso).trim()) return '';
  const d = new Date(String(iso).trim());
  if (Number.isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const h = String(d.getHours()).padStart(2, '0');
  const min = String(d.getMinutes()).padStart(2, '0');
  return `${y}-${m}-${day}T${h}:${min}`;
}
